module Meevo.Components.Controls {

    import IReportDrawerHistoryListItem = Meevo.Components.Controls.IReportDrawerHistoryListItem;

    class OpenCloseHistoryModalController {
        public list: Array<IReportDrawerHistoryListItem>;
        public showSeconds: boolean;
        public showAmPm: boolean;
        public dateTimeFormat: string = 'EEE M/dd/yyyy';

        static $inject = [
            '$mdDialog',
            '$translate'
        ];

        constructor(
            protected $mdDialog: angular.material.IDialogService,
            private $translate: angular.translate.ITranslateService) {
    
            let hourFormat = this.showAmPm ? 'h' : 'H';
            let secondsFormat = this.showSeconds ? ':ss' : '';
            let amPmFormat = this.showAmPm ? ' a' : '';
            this.dateTimeFormat += ` ${hourFormat}:mm${secondsFormat}${amPmFormat}`;
        }

        /**
         * Mark item as selected
         * @param {IOpenCloseHistoryItem} item
         */
        public markItem(item: IReportDrawerHistoryListItem): void {
            if (item.isSelected) {
                item.isSelected = false;
                return;
            }

            this.list.forEach((item: IReportDrawerHistoryListItem) => {
                item.isSelected = false;
            });

            item.isSelected = true;
        }

        /**
         * Close modal window
         * */
        public closeModal(): void {
            this.$mdDialog.cancel();
        }

        /**
         * Confirm selection
         */
        public apply(): void {
            let selectedItem = _.find(this.list, (item: IReportDrawerHistoryListItem) => item.isSelected);

            this.$mdDialog.hide(selectedItem);
        }
    }

    angular.module('meevo.components.controls')
        .controller('meevo.components.controls.openCloseHistoryModalController', OpenCloseHistoryModalController);
}